// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
import { getStoryBySlug, Hero } from '@cinch-nx/data-storyblok'
import { SEOPageStoryContent } from './types/seo-page'
import { GetStaticPropsContext } from 'next'

export interface GetStaticPropsGeneratorArgs {
  path: string
}

export const getStaticPropsGenerator =
  (path: GetStaticPropsGeneratorArgs) =>
  async ({ params, preview = false }: GetStaticPropsContext) => {
    try {
      const slug = params ? (params?.['slug'] as string) : 'index'

      const story = await getStoryBySlug<SEOPageStoryContent>(
        `${path}/${slug}`,
        {
          version: preview ? 'draft' : 'published',
          cv: Date.now(),
        },
      )

      if (!story) {
        throw new Error('Seo page failed to get story')
      }

      const HeroProps: Hero = story.content?.hero[0]

      return {
        props: {
          story,
          preview,
          layoutProps: {
            heroProps: HeroProps,
            showBorderRadius: true,
            showFooterBorderRadius: false,
          },
        },
        revalidate: 60, // In seconds
      }
    } catch (error) {
      console.log(error)
      return {
        notFound: true,
        props: {
          story: null,
          preview,
          layoutProps: {
            heroProps: {},
            showBorderRadius: true,
            showFooterBorderRadius: false,
          },
        },
        revalidate: 60, // In seconds
      }
    }
  }

export type SeoPageProps = Extract<
  Awaited<ReturnType<ReturnType<typeof getStaticPropsGenerator>>>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { props: any }
>['props']
